<app-header></app-header>
<div class="title"></div>
<div class="container margin-top-70">
  <div class="row">
    <div class="col-md-6 mt-6">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td class="v-align-m">
              Start Date
            </td>
            <td>
              <app-date-select
                class="form-control"
                [additionalClasses]="'float-left'"
                type="startDate"
                (dateSelected)="updateSelectedDate($event)"
              ></app-date-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-md-6 mt-6">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td class="v-align-m">
              End Date
            </td>
            <td>
              <app-date-select
                class="form-control"
                [additionalClasses]="'float-left'"
                type="endDate"
                (dateSelected)="updateSelectedDate($event)"
              ></app-date-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="container">
  <div class="card">
    <div class="card-body" style="font-size: 12px;">
      <p>
        Please note that this report requires start date and end date correctly.
        <br />
        After selecting the start date and end date click on search button to
        view the report and download button to download the report.
      </p>
    </div>
  </div>
</div>

<div class="container table-responsive mt-2">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      [disabled]="showSearchLoading"
      type="submit"
      class="btn btn-primary btn-pkt"
      (click)="searchProduct()"
    >
      {{searchBtnText}}
      <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
      <span
        *ngIf="showSearchLoading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </button>
    <button
      class="btn btn-primary btn-pkt"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
    <button class="btn btn-primary btn-pkt" (click)="clearFilters()">
      Reset<i class="bi bi-trash ps-1"></i>
    </button>
  </div>
</div>

<div>
  <div class="container" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col" style="width: 10%;">Date</th>
          <th scope="col" style="width: 10%;">Name</th>
          <th scope="col" style="width: 10%;">Email Address</th>
          <th scope="col" style="width: 10%;">Role</th>
          <th scope="col" style="width: 10%;">Department</th>
          <th scope="col" style="width: 10%;">Product Id</th>
          <th scope="col" style="width: 10%;">Book Type</th>
          <th scope="col" style="width: 10%;">Title</th>
          <th scope="col" style="width: 10%;">ISBN-13P</th>
          <th scope="col" style="width: 10%;">ISBN-10P</th>
          <th scope="col" style="width: 10%;">ISBN-13E</th>
          <th scope="col" style="width: 10%;">ISBN-10E</th>
          <th scope="col" style="width: 10%;">Contract Date</th>
          <th scope="col" style="width: 10%;">Cancelled Date</th>
          <th scope="col" style="width: 10%;">Published Date</th>
          <th scope="col" style="width: 10%;">Book Activity</th>
          <th scope="col" style="width: 10%;">Non Book Activity</th>
          <th scope="col" style="width: 10%;">Brand</th>
          <th scope="col" style="width: 10%;">Total Time</th>
          <th scope="col" style="width: 10%;">Hours</th>
          <th scope="col" style="width: 10%;">Minutes</th>
          <th scope="col" style="width: 10%;">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; let i = index;">
          <td>{{product?.Date}}</td>
          <td>{{product?.Name}}</td>
          <td>{{product?.Email_Address}}</td>
          <td>{{product?.Role}}</td>
          <td>{{product?.Department}}</td>
          <td>{{product?.Product_ID}}</td>
          <td>{{product?.Book_Type}}</td>
          <td>{{product?.Title}}</td>
          <td>{{product?.ISBN_13P}}</td>
          <td>{{product?.ISBN_10P}}</td>
          <td>{{product?.ISBN_13E}}</td>
          <td>{{product?.ISBN_10E}}</td>
          <td>{{product?.Contract_Date}}</td>
          <td>{{product?.Canncelled_Date}}</td>
          <td>{{product?.Published_Date}}</td>
          <td>{{product?.Book_Activity}}</td>
          <td>{{product?.Non_Book_Activity}}</td>
          <td>{{product?.Brand}}</td>
          <td>{{product?.Total_Time}}</td>
          <td>{{product?.hours}}</td>
          <td>{{product?.Minutes}}</td>
          <td>{{product?.Status}}</td>
          {{assignTotalValue(product?.Total_Rows)}}
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>

<app-footer></app-footer>
<ngb-toast
  class="toast-container position-fixed top-0 end-0 p-3"
  style="z-index: 1200; background-color: #871919; color: aliceblue;"
  *ngIf="successToastShow"
  [autohide]="true"
  (hidden)="successToastShow=false"
>
  Please select both start and end dates to get the data!
</ngb-toast>
